import { Injectable } from '@angular/core';
import {
   HttpInterceptor,
    HttpRequest,
    HttpResponse,
    HttpHandler,
    HttpEvent,
    HttpErrorResponse
} from '@angular/common/http'
import { Observable, throwError } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { Router } from '@angular/router'
//import { HelperService } from '../api/helper.service'

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  
  constructor(
     private route:Router,
     //private help:HelperService,
  ){

  }

   intercept(req:HttpRequest<any>, next:HttpHandler):
     Observable<HttpEvent<any>> {
       //GET URL
       //GET Status Code

       //console.log('Request'  + req.url)
      
       return next.handle(req).pipe(
         map(
           (event: HttpEvent<any>) => {
             //validate if there is an event
             if(event instanceof HttpResponse) {
               console.log('Event --->>', event);
               console.log('Status',event.status)
             }
             return event
           }
         ),
         catchError(
           (error: HttpErrorResponse) => {
             if(error.status==400 || error.status==401){
               //Check if source url is authenticate 
               if(req.url.includes("authenticate")){
                 return throwError(error) 
               }else{
                 
                //this.help.msgBox("Authentication","Login Expired")
                this.route.navigateByUrl("/login")
                return
               }
             }else if(error.status == 406){
               const herr = this.getError(error.error)
               console.log('validation issue:',herr)
               return throwError(herr)
             }else{
              return throwError(error)
             }
             
             return throwError(error);
           }
         )
       )

      //  return next.handle(req).pipe(
      //   map((event: HttpEvent<any>) => {
      //       if (event instanceof HttpResponse) {
      //           console.log('event--->>>', event);
      //       }
      //       return event;
      //   }));
      
     }

     getError(err:any){
       const errors =[]

       //Check if error exist
       if(err.error){
       
          //Loop through each field name
          for(const property in err.error){
           
            if(err.error.hasOwnProperty(property)){
              
              //Get each error message per field
              const propertyErrors: Array<string> = err.error[property]
              
              //Loop through each message on each field
              propertyErrors.forEach(
                (error) => {
                  errors.push(error)
                }
              )
            }
          }
       }else{
         return err;
       }
       let error_list:string = '';
       const new_err = errors.map((val) => error_list = error_list + (error_list ? "<br>" :'') + val)
       const err_format = {
          'error_array' : errors,
          'error_message' : error_list
       }
       return err_format;
      
     }
  
}
